import styled from "@emotion/styled";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";

import StyledInput from "./StyledFormInput";

import Select from "react-select";

const FormSelect = forwardRef((props, ref) => {
  const [isEmptyDisabled, setIsEmptyDisabled] = useState(false);
  const { input, config, layout, value, extraOptions, tags, setTags } = props;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (extraOptions) {
      input.options = extraOptions;
    }
  }, [extraOptions]);

  useImperativeHandle(ref, () => ({
    reset() {
      input.setValue("");
      input.inputRef.current.value = "";
      onChange();
    },
  }));

  useEffect(() => {
    setIsEmptyDisabled(
      !input.validations?.filter((validation) => validation.type === "required")
        .length
    );
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (input?.startValue && input.inputRef.current) {
        input.inputRef.current.value = input.startValue;
        onChange();
      }
    }, 500);
  }, [input.startValue]);

  const onChange = () => {
    if (input.onChange) {
      input.onChange(input.inputRef.current.value);
    }
  };

  const handleChangeMulti = (tags) => {
    setTags(tags);
  };

  return (
    <StyledFormSelect config={config}>
      <StyledInput
        style={{ padding: 0 }}
        config={config}
        className={`input__group ${layout} ${input?.type}-input`}
      >
        <StyledMultiSelect
          isMulti
          options={input.options}
          value={tags}
          styles={{
            control: (provided, state) => ({
              ...provided,
              borderColor: "#444",
              boxShadow: state.isFocused
                ? "0 0 0 1px #d8d8d8"
                : provided.boxShadow,
              paddingTop: tags?.length >= 4 ? 6 : 0,
              "&:hover": {
                borderColor: "#d8d8d8",
              },
            }),
            menu: (provided) => ({
              ...provided,
              zIndex: 9999,
              color: "#444",
              paddingTop: 18,
            }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.isFocused
                ? "#d8d8d8"
                : provided.backgroundColor,
              borderColor: state.isFocused
                ? "#d8d8d8"
                : provided.backgroundColor,
              ":hover": {
                backgroundColor: "#f0f0f0",
                cursor: "pointer",
              },
            }),
          }}
          onChange={handleChangeMulti}
          onMenuOpen={(e) => setOpen(true)}
          onMenuClose={(e) => setOpen(false)}
          placeholder=" "
        />

        <label>
          <div className={"label-bg"} />
          <p
            style={
              open || tags?.length > 0
                ? {
                    background: "white",
                    padding: 1,
                    marginTop: -20,
                    fontSize: "0.9em",
                    color: "#8BA412",
                  }
                : { marginLeft: 4, marginTop: 4 }
            }
            className={"label-show"}
          >
            {input?.label || "Input"}
          </p>
        </label>
        <p className="error">{input?.error}</p>
        {input?.append && <div className="append">{input?.append}</div>}
      </StyledInput>
    </StyledFormSelect>
  );
});

export default FormSelect;

/* style */

const StyledFormSelect = styled.div``;

const StyledMultiSelect = styled(Select)`
  .css-6j8wv5-Input {
    margin: 0px;
    padding: 0px;
  }

  .css-319lph-ValueContainer {
    margin: 0px;
    padding: 0px;
    padding-left: 10px;
  }

  .css-g1d714-ValueContainer {
    margin: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .css-1rhbuit-multiValue {
    margin: 2px;
    padding: 0px;
    border-radius: 4px;
  }

  & span {
    display: none;
  }

  & svg {
    background-color: #f3f7e0;
    border-radius: 12px;
  }

  label {
    color: red;
  }
`;
